import { Route, Switch } from "react-router-dom";
import Tabs from "./EditarPerfilTabs";

function EditarPerfilPages() {
  return (
    <Switch>
      <Route path="/editar-perfil" component={Tabs} />
    </Switch>
  );
}

export default EditarPerfilPages;
